<template>
  <!-- 银行回单 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="资金分簿名称:" prop="subAccName">
                <el-input  placeholder="" v-model="searchFrom.subAccName" ></el-input>
              </el-form-item>
              <el-form-item label="对方账号:" prop="accountNo">
                <el-input  placeholder="" v-model="searchFrom.accountNo"></el-input>
              </el-form-item>
               <el-form-item label="对方账户名称:" prop="accountNm">
                <el-input  placeholder="" v-model="searchFrom.accountNm"></el-input>
              </el-form-item>
             <el-form-item label="交易日期:" prop="tranDates">
                <el-date-picker
                  v-model="searchFrom.tranDates"
                  format="yyyy-MM-dd "
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
            <div>
              <el-form-item btnCode="00JP009B001" >
                <el-button type="primary" @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="huidanFn">回单</el-button>
                <!-- <el-link type="primary" :href="global.ZXpingzheng+'subAccNo='+scope.row.subAccNo+'&printVerifyCode='+scope.row.verifyCode+''"  target="_blank">回单</el-link> -->
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="huoquFn">手动获取</el-button>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="排序:" prop="orderBy" class="ziti" >
                <template >
                  <el-radio-group v-model="searchFrom.orderBy" @change="orderByFn">
                    <el-radio :label="true" >正序</el-radio>
                    <el-radio :label="false">倒序</el-radio>
                  </el-radio-group>
                </template>
              </el-form-item>
            </div>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
         <el-table-column property="subAccName" width="330"  :formatter="emptyFn"   label="资金分簿名称"></el-table-column>
        <el-table-column property="subAccNo"  width="200"  :formatter="emptyFn"   label="资金分簿号"></el-table-column>
         <el-table-column property="tellerNo" width="200"  :formatter="emptyFn"   label="柜员交易号"></el-table-column>
        <el-table-column property="tranAmt"  width="120"  :formatter="emptyFn"   label="交易金额(元)"></el-table-column>
        <el-table-column property="accountNm"   width="320"  :formatter="emptyFn"   label="对方账户名称"></el-table-column>
        <el-table-column property="accBnkNm" width="300" :formatter="emptyFn"   label="对方开户名称"></el-table-column>
        <el-table-column property="accountNo"  width="240"  :formatter="emptyFn"   label="对方账号"></el-table-column>
        <el-table-column property="tranType"   width="140"  :formatter="typeFormat"   label="交易类型"></el-table-column>
        <el-table-column property="tranDate"  width="120"  :formatter="dateFormat"   label="交易日期"></el-table-column>
        <el-table-column property="tranTime"  width="120"  :formatter="timeFormat"   label="交易时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 手动获取 -->
    <el-dialog  title="手动获取"  :visible.sync="HQMark" width="450px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form  :data="huoquList" :inline="true"  :model="HQFrom" ref="HQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="100px" size="mini" >
            <el-form-item label="账户:" class="jiage" prop="accountType" v-if="huoquList.length>1">
              <el-select  v-model="HQFrom.accountType"  value-key="id"  placeholder="请选择"  style="width: 240px">
                <el-option v-for="item in huoquList" :label="item.zxAccNm" :value="item" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="账户:" v-if="huoquList.length==1">
              <el-input  placeholder="" class="disabled" style="width: 240px" :readonly="true"  type="tel" v-model="huoquList[0].zxAccNm" ></el-input>
            </el-form-item>
            <el-form-item label="日期:" prop="tranDate">
               <!-- <el-date-picker
                  v-model="HQFrom.tranDates"
                  format="yyyy-MM-dd "
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker> -->
                <el-date-picker
                  style="width: 240px"
                  v-model="HQFrom.tranDate"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="HQMark = false">取消</el-button>
        <el-button type="primary" @click="HQsave()">确定</el-button>
      </span>
   </el-dialog>
 </div>

</template>

<script>
import { emptyFn, dateTimeFormat } from '@/utils/util'
import {
  zCiticBankReceipt, // 列表
  tAccountList, // 获取账户列表接口
  manualBbankReceipt// 手动获取回单接口
} from '@/api/consignment'
export default {
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 手动获取
      HQFrom: {
      },
      HQMark: false,
      huoquList: [],
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        orderBy: false
      },
      tableList: [],
      loading: 'false',
      total: 0,
      rules: {
        reason: { required: true, message: '请输入拒绝原因', trigger: 'blur' },
        tranDate: { required: true, message: '请输入日期', trigger: 'blur' },
        accountType: { required: true, message: '请选择账户', trigger: 'blur' }
      }
    }
  },
  created () {
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 手动获取
    huoquFn () {
      this.HQMark = true
      this.$nextTick(() => {
        this.$refs['HQFrom'].clearValidate()
      })
      this.getNowTime()
      tAccountList().then(res => {
        this.huoquList = res
        if (res.length == 1) {
          this.HQFrom.zxAccNm = res[0].zxAccNm
          this.HQFrom.zxAccNo = res[0].zxAccNo
        }
      })
    },
    getNowTime () {
      var now = new Date()
      var year = now.getFullYear() // 得到年份
      var month = now.getMonth() // 得到月份
      var date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      var defaultDate = `${year}-${month}-${date}`
      this.$set(this.HQFrom, 'tranDate', defaultDate)
    },
    HQsave () {
      this.$refs.HQFrom.validate((valid) => {
        if (valid) {
          if (this.HQFrom.accountType) {
            this.HQFrom.zxAccNm = this.HQFrom.accountType.zxAccNm
            this.HQFrom.zxAccNo = this.HQFrom.accountType.zxAccNo
            delete this.HQFrom.accountType
          }
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          manualBbankReceipt(this.HQFrom).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            // this.tiaojiaMark = false
            this.HQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 回单
    huidanFn () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1 || selectData.length > 10) {
        this.$alert('请选择1-10条要操作的数据', '系统提示')
      } else {
        var subAccNo = ''// global.ZXpingzheng
        var printVerifyCode = ''
        selectData.forEach((item, index) => {
          if (index == selectData.length - 1) {
            subAccNo += item.subAccNo
            printVerifyCode += item.verifyCode
          } else {
            subAccNo += item.subAccNo + ','
            printVerifyCode += item.verifyCode + ','
          }
        })
        let url = this.global.ZXpingzheng + 'subAccNo=' + subAccNo + '&printVerifyCode=' + printVerifyCode
        console.log(url)
        window.open(url)
      }
    },
    orderByFn () {
      this.getList(this.searchFrom)
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      zCiticBankReceipt(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            this.loading = false
          }
        })
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },
    // 获取年月
    getLastMonth () { // 获取上个月日期
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth()
      if (month == 0) {
        year = year - 1
        month = 12
      }
      return year + '-' + month
    },
    // 日期处理
    dateFormat (row, column, cellValue) {
      let y = cellValue.substring(0, 4)
      let M = cellValue.substring(4, 6)
      let d = cellValue.substring(6, 8)
      return y + '-' + M + '-' + d
    },
    // 时间处理
    timeFormat (row, column, cellValue) {
      let h = cellValue.substring(0, 2)
      let m = cellValue.substring(2, 4)
      let s = cellValue.substring(4, 6)
      return h + ':' + m + ':' + s
    },
    // 类型格式化
    typeFormat (row, column, cellValue) {
      switch (cellValue) {
        case '11':
          return '普通转账'
        case '12':
          return '资金初始化'
        case '13':
          return '利息分配'
        case '14':
          return '手续费分配'
        case '15':
          return '强制转账'
        case '16':
          return '调账'
        case '21':
          return '公共利息收费账户转账'
        case '22':
          return '公共调账账户外部转账'
        case '23':
          return '普通外部转账'
      }
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        tranDate: null,
        orderBy: false
      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
      this.HQFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
/deep/.el-link.el-link--primary{
  color: #0e6eec;
    font-size: 12px;
}
/deep/.el-form--inline{
  width: 95%;
}
.searchBtnBox{
   width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
